export const PatchSetLoanCalculator = {
  dehydrate(loan, periodNum) {
    return {
      op: "processPatchSetLoanCalculator",
      id: loan.id,
      principal_currency: loan.principalCurrency,
      principal_amount: loan.principalAmount,
      setup_fee_currency: loan.setupFeeCurrency,
      setup_fee_amount: loan.setupFeeAmount,
      setup_fee_type: loan.setupFeeType,
      term_period: Math.ceil(periodNum),
      term_type: "type_period",
      term_interval: loan.termInterval,
      loan_program_name: loan.loanProgramName,
      loan_program_merchant_discount_percentage:
        loan.loanProgramMerchantDiscountPercentage,
      annual_interest: loan.annualInterest,
    };
  },
};
